
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/live-psychic-chat-app",
      function () {
        return require("private-next-pages/live-psychic-chat-app.tsx");
      }
    ]);
  